export function setRiskGapAnswer(gap: RiskGapType): RiskGapType {
    let uiAnswer: boolean | null = null;
    if (gap?.submission_answer?.answer === 1) uiAnswer = true;
    if (gap?.submission_answer?.answer === 2) uiAnswer = false;
    return { ...gap, uiAnswer };
}
